import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a5e98fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login flex h-full bg-white overflow-hidden" }
const _hoisted_2 = { class: "left relative w-1/2 xl:block h-full bg-primary rounded-r-2xl hidden" }
const _hoisted_3 = { class: "right w-full xl:w-1/2 h-full flex bg-white z-30 overflow-y-auto relative px-10" }
const _hoisted_4 = { class: "fixed pt-12 bg-white w-full" }
const _hoisted_5 = { class: "ubuntu text-primary pl-2" }
const _hoisted_6 = { class: "centered m-auto py-16 w-full mt-8 sm:mt-16" }
const _hoisted_7 = { class: "ubuntu font-bold text-xl" }
const _hoisted_8 = { class: "open-sans" }
const _hoisted_9 = { class: "mt-6 sm:mt-12" }
const _hoisted_10 = { class: "name-and-surname grid grid-cols-1 gap-4 sm:grid-cols-2" }
const _hoisted_11 = { class: "name-input" }
const _hoisted_12 = ["placeholder", "disabled"]
const _hoisted_13 = { class: "surname-input" }
const _hoisted_14 = ["placeholder", "disabled"]
const _hoisted_15 = { class: "errors grid" }
const _hoisted_16 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_17 = {
  key: 1,
  class: "font-light text-red-500"
}
const _hoisted_18 = {
  key: 2,
  class: "font-light text-red-500"
}
const _hoisted_19 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_20 = {
  key: 1,
  class: "font-light text-red-500"
}
const _hoisted_21 = {
  key: 2,
  class: "font-light text-red-500"
}
const _hoisted_22 = { class: "mt-5" }
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_25 = {
  key: 1,
  class: "font-light text-red-500"
}
const _hoisted_26 = { class: "mt-5 relative" }
const _hoisted_27 = ["type", "placeholder", "disabled"]
const _hoisted_28 = { class: "see-password cursor-pointer text-right float-right max-w-fit right-4 absolute top-5" }
const _hoisted_29 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_30 = {
  key: 1,
  class: "font-light text-red-500"
}
const _hoisted_31 = {
  key: 2,
  class: "font-light text-red-500"
}
const _hoisted_32 = { class: "mt-5 relative" }
const _hoisted_33 = ["type", "placeholder", "disabled"]
const _hoisted_34 = { class: "see-password cursor-pointer text-right float-right max-w-fit right-4 absolute top-5" }
const _hoisted_35 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_36 = {
  key: 1,
  class: "font-light text-red-500"
}
const _hoisted_37 = { class: "mt-8 flex" }
const _hoisted_38 = {
  class: "font-bold",
  href: "https://akad.it/terms-of-service",
  target: "_blank"
}
const _hoisted_39 = { class: "mt-10 flex" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  key: 0,
  class: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  style: {"display":"inherit","margin-bottom":"2px"}
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1))
const _hoisted_44 = [
  _hoisted_42,
  _hoisted_43
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackGround = _resolveComponent("BackGround")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_custom_loader = _resolveComponent("custom-loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_BackGround, { class: "absolute bottom-0" })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "back-to-login flex items-center cursor-pointer max-w-fit",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack()))
          }, [
            _createVNode(_component_font_awesome_icon, {
              class: "h-4 text-secondary",
              icon: ['fas', 'circle-arrow-left']
            }),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('sign-up-page.button.back')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('sign-up-page.title')), 1),
          _createElementVNode("form", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["appearance-none rounded w-full px-3 text-black-700 leading-tight bg-gray-100 focus:outline-none focus:shadow-outline", { disabled: _ctx.isLoading, border: _ctx.v$.name.$error }]),
                    type: "text",
                    placeholder: _ctx.$t('sign-up-page.name.placeholder'),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
                    onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.v$.name.$touch && _ctx.v$.name.$touch(...args))),
                    disabled: _ctx.isLoading
                  }, null, 42, _hoisted_12), [
                    [_vModelText, _ctx.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["appearance-none rounded w-full px-3 text-black-700 leading-tight bg-gray-100 focus:outline-none focus:shadow-outline", { disabled: _ctx.isLoading, border: _ctx.v$.surname.$error }]),
                    type: "text",
                    placeholder: _ctx.$t('sign-up-page.surname.placeholder'),
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.surname) = $event)),
                    onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.v$.surname.$touch && _ctx.v$.surname.$touch(...args))),
                    disabled: _ctx.isLoading
                  }, null, 42, _hoisted_14), [
                    [_vModelText, _ctx.surname]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.name.$errors, (error) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: error.$uid
                  }, [
                    (error.$validator == 'required')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_16, _toDisplayString(_ctx.$t('sign-up-page.name.required')), 1))
                      : _createCommentVNode("", true),
                    (error.$validator == 'minLength')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_17, _toDisplayString(_ctx.$t('sign-up-page.name.min-length', { chars: _ctx.nameMinLength })), 1))
                      : _createCommentVNode("", true),
                    (error.$validator == 'maxLength')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_18, _toDisplayString(_ctx.$t('sign-up-page.name.max-length', { chars: _ctx.nameMaxLength })), 1))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.surname.$errors, (error) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: error.$uid
                  }, [
                    (error.$validator == 'required')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_19, _toDisplayString(_ctx.$t('sign-up-page.surname.required')), 1))
                      : _createCommentVNode("", true),
                    (error.$validator == 'minLength')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_20, _toDisplayString(_ctx.$t('sign-up-page.surname.min-length', { chars: _ctx.surnameMinLength })), 1))
                      : _createCommentVNode("", true),
                    (error.$validator == 'maxLength')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_21, _toDisplayString(_ctx.$t('sign-up-page.surname.max-length', { chars: _ctx.surnameMaxLength })), 1))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["appearance-none rounded w-full px-3 text-black-700 leading-tight bg-gray-100 focus:outline-none focus:shadow-outline", { border: _ctx.v$.email.$error }]),
                type: "email",
                placeholder: _ctx.$t('sign-up-page.email.placeholder'),
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.email) = $event)),
                onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.v$.email.$touch && _ctx.v$.email.$touch(...args)))
              }, null, 42, _hoisted_23), [
                [_vModelText, _ctx.email]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.email.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "errors grid",
                  key: error.$uid
                }, [
                  (error.$validator == 'required')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_24, _toDisplayString(_ctx.$t('sign-up-page.email.required')), 1))
                    : _createCommentVNode("", true),
                  (error.$validator == 'email')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_25, _toDisplayString(_ctx.$t('sign-up-page.email.valid')), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_26, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["appearance-none rounded w-full px-3 text-black-700 leading-tight bg-gray-100 focus:outline-none focus:shadow-outline", { disabled: _ctx.isLoading, border: _ctx.v$.password.$error }]),
                id: "password",
                type: _ctx.passwordFieldTypePassword,
                placeholder: _ctx.$t('sign-up-page.password.placeholder'),
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.password) = $event)),
                onBlur: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.v$.password.$touch && _ctx.v$.password.$touch(...args))),
                disabled: _ctx.isLoading
              }, null, 42, _hoisted_27), [
                [_vModelDynamic, _ctx.password]
              ]),
              _createElementVNode("div", _hoisted_28, [
                (_ctx.isSeePassword)
                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 0,
                      class: "h-5",
                      icon: ['fas', 'eye-slash'],
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.seeHidePassword()))
                    }))
                  : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 1,
                      class: "h-5",
                      icon: ['fas', 'eye'],
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.seeHidePassword()))
                    }))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.password.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "errors grid",
                  key: error.$uid
                }, [
                  (error.$validator == 'required')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_29, _toDisplayString(_ctx.$t('sign-up-page.password.required')), 1))
                    : _createCommentVNode("", true),
                  (error.$validator == 'minLength')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_30, _toDisplayString(_ctx.$t('sign-up-page.password.min-length', { chars: _ctx.passwordMinLength })), 1))
                    : _createCommentVNode("", true),
                  (error.$validator == 'maxLength')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_31, _toDisplayString(_ctx.$t('sign-up-page.password.max-length', { chars: _ctx.passwordMaxLength })), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_32, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["appearance-none rounded w-full px-3 text-black-700 leading-tight bg-gray-100 focus:outline-none focus:shadow-outline", { disabled: _ctx.isLoading, border: _ctx.v$.passwordConfirm.$error }]),
                id: "password-confirm",
                type: _ctx.passwordFieldTypePasswordConfirmation,
                placeholder: _ctx.$t('sign-up-page.password-confirm.placeholder'),
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.passwordConfirm) = $event)),
                onBlur: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.v$.passwordConfirm.$touch && _ctx.v$.passwordConfirm.$touch(...args))),
                disabled: _ctx.isLoading
              }, null, 42, _hoisted_33), [
                [_vModelDynamic, _ctx.passwordConfirm]
              ]),
              _createElementVNode("div", _hoisted_34, [
                (_ctx.isSeePasswordConfirmation)
                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 0,
                      class: "h-5",
                      icon: ['fas', 'eye-slash'],
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.seeHidePasswordConfirmation()))
                    }))
                  : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 1,
                      class: "h-5",
                      icon: ['fas', 'eye'],
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.seeHidePasswordConfirmation()))
                    }))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.passwordConfirm.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "errors",
                  key: error.$uid
                }, [
                  (error.$validator == 'required')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_35, _toDisplayString(_ctx.$t('sign-up-page.password-confirm.required')), 1))
                    : _createCommentVNode("", true),
                  (error.$validator == 'match')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_36, _toDisplayString(_ctx.$t('sign-up-page.password-confirm.match')), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createVNode(_component_CheckBox, {
                onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onCheckBox())),
                "model-value": _ctx.isTermsAndConditionsChecked
              }, null, 8, ["model-value"]),
              _createElementVNode("p", {
                class: "cursor-pointer",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onCheckBox()))
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t('sign-up-page.terms-and-conditions.placeholder')) + " ", 1),
                _createElementVNode("a", _hoisted_38, _toDisplayString(_ctx.$t('sign-up-page.button.terms-and-conditions')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("button", {
                class: _normalizeClass(["mx-auto max-w-sm bg-primary text-white text-xl font-bold py-4 px-4 rounded w-full ubuntu hover:bg-primary-600 focus:outline-none focus:shadow-outline", { disabled : _ctx.v$.$invalid || _ctx.isLoading }]),
                type: "button",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.onSignUp && _ctx.onSignUp(...args))),
                disabled: _ctx.v$.$invalid || _ctx.isLoading
              }, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_41, _hoisted_44))
                  : _createCommentVNode("", true),
                _createTextVNode(_toDisplayString(_ctx.$t('sign-up-page.button.create-account')), 1)
              ], 10, _hoisted_40)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_custom_loader, {
          key: 0,
          color: "#085180",
          scale: "0.6"
        }))
      : _createCommentVNode("", true)
  ], 64))
}